import { Injectable } from '@angular/core';
import { HttpClientService } from '../httpClient/httpClient.service';
import { authenticationApis } from '../../constants/api-constant/authentication-apis';
import { Observable } from 'rxjs';
import { LocalStorageService } from '../localStorage/localStorage.service';
import { localStorageVars } from '../../constants/common.const';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root',
})
export class AuthenticationService {
    private lConstant = localStorageVars;

    constructor(
        private httpClientService: HttpClientService,
        private localStorageService: LocalStorageService
    ) {}

    login(payload: unknown): Observable<any> {
        return this.httpClientService.post(
            authenticationApis.login,
            payload,
            true
        );
    }

    forgotPassowrd(payload: unknown): Observable<any> {
        return this.httpClientService.post(
            authenticationApis.forgotPassword,
            payload,
            true
        );
    }

    resetPassword(payload: unknown): Observable<any> {
        return this.httpClientService.getResetPasswordAuth(
            authenticationApis.resetPassword,
            payload
        );
    }

    decodeResetToken(token: string): Observable<any> {
        const query = `${authenticationApis.decodeForgotPasswordToken}?code=${token}`;
        return this.httpClientService.get(query, true);
    }

    scenner(): Observable<any> {
        return this.httpClientService.get(authenticationApis.getScanner);
    }

    refreshTokenFetch() {
        const refreshToken = this.localStorageService.getRefreshKey();
        const payload = {
            refreshToken: refreshToken,
        };
        this.httpClientService
            .post(authenticationApis.changeRefreshToken, payload)
            .subscribe((res: any) => {
                this.localStorageService.setKey(
                    'access_token',
                    res?.access?.token
                );
                this.localStorageService.setRefreshKey(res?.refresh?.token);
            });
    }

    // MOU Service
    getTEMPUser(): Object {
        return JSON.parse(localStorage.getItem(this.lConstant.tempUserObj)!);
    }

    setUser(data: Object) {
        localStorage.setItem(this.lConstant.userObj, JSON.stringify(data));
    }

    sendContactUs(payload: unknown): Observable<any> {
        return this.httpClientService.post(
            authenticationApis.contactUsURL,
            payload
        );
    }

    navigateToOldPortal(userEmail: any): Observable<any> {
        const userDetails = this.localStorageService.getUser();
        const tenantId = '3' //environment.tenant;
        const email =  'kunal@webstylio.com' //userDetails?.email;
        return this.httpClientService.post(authenticationApis.oldPortalApi, {
            email,
            tenantId,
        });
    }

    
    autoLoginAgent(payload:any, headers:any) : Observable<any> {
        return this.httpClientService.autologinpost(
            authenticationApis.autoLoginAgent,
            payload,
            headers
        );
    }

    autoLoginAgentViaAdmin(payload:any, headers:any) : Observable<any> {
        return this.httpClientService.autologinpostforadmin(
            authenticationApis.autoLoginAgentForAdmin,
            payload,
            headers
        );
    }

    checkShowTechnicalSupportButtonOrNot() : Observable<any> {
        return this.httpClientService.get(
            authenticationApis.checkShowTechnicalSupportButtonOrNot,
        );
    }

    getAccessToken(refreshToken) {
        return this.httpClientService.postAccessToken(authenticationApis.getAccessToken, { token: refreshToken });
    }

    logout(payload: unknown): Observable<any> {
        return this.httpClientService.postAccessToken(
            authenticationApis.logout,
            payload,
        );
    }
}
